import options from './options';
import components from './components';

type QuestionKey =
  | 'clientele'
  | 'contact_information'
  | 'date'
  | 'human_resources'
  | 'likert'
  | 'long_text'
  | 'mailing_address'
  | 'multiple_choice'
  | 'points_of_service'
  | 'rich_text'
  | 'short_text'
  | 'sub_organization'
  | 'table_format'
  | 'text_block';

export default {
  options,
  components,
};
export { QuestionKey };
